import React, { useEffect, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { UncontrolledDropdown, NavbarText, DropdownToggle, DropdownMenu, DropdownItem } from 'src/components/ui';
import CustomBadge from './CustomBadge';
import Loader from './Loader';
import { useOpenCases } from '../context/OpenCasesContext';
import Icon from 'src/components/Icon';

const DropdownOrganizationSelected = props => {
  const { auth, history } = props;

  const [init, setInit] = useState(false);

  useEffect(() => {
    if (init) return;
    if (!auth) return;

    const actualOrg = auth?.user?.user?.actualOrganizationalUnitId;
    const roles = auth?.user?.organizationalUnitRoles ?? [];

    if (roles.length === 0) {
      setInit(true);
      return;
    }

    const actualRole = roles.find(r => r.organizationalUnitId == actualOrg);
    const needsUpdate = !actualOrg || !actualRole;

    if (needsUpdate) {
      auth.setOrganizationalUnit(roles[0].organizationalUnitId);
      setInit(true);
      return;
    }
  }, [init, auth]);

  const user = auth?.user?.user;
  // const data = useOpenCases();
  // const totalOpenCases = data?.reduce((sum, item) => sum + item.openCases, 0) || 0;

  return (
    <UncontrolledDropdown nav>
      {/* {totalOpenCases ? (
        <CustomBadge
          color="danger"
          style={{
            fontSize: 15,
            marginLeft: 8,
            position: 'absolute',
            top: '-2px',
            right: '-12px',
          }}
          pill
        >
          {totalOpenCases}
        </CustomBadge>
      ) : null} */}
      <NavbarText className="flex items-center" style={{ padding: 0, paddingRight: 8 }}>
        <DropdownToggle
          nav
          caret={false}
          className="flex justify-between items-center w-full dropdownOrganizationSelected simple-dropdown-toggle flex-important"
        >
          <Trans>Working in:</Trans> {auth.user?.organizationalUnits.find(x => x.id === user?.actualOrganizationalUnitId)?.name}
          <Icon icon="CaretDown" style={{ marginLeft: 8 }} />
        </DropdownToggle>
      </NavbarText>

      <DropdownMenu
        className="dropdown-organization-selected"
        style={{
          padding: 0,
          paddingLeft: 0,
          margin: 0,
          fontSize: 14,
          top: 60,
          minWidth: 220,
        }}
      >
        {(auth?.user?.organizationalUnits || []).map((unit, idx) => (
          <React.Fragment key={idx}>
            {idx > 0 ? <hr className="dropdown-divider" /> : null}
            <DropdownItem
              className="vertical-animated-slow-show"
              style={{
                paddingLeft: '10px',
              }}
              key={idx}
              onClick={() => {
                auth.setOrganizationalUnit(unit.id);
                history.push('/');
              }}
            >
              <div style={{ paddingBottom: 3 }}>
                <span
                  style={{
                    fontWeight: 'bold',
                    fontSize: 13,
                    color: unit.id === user.actualOrganizationalUnitId ? 'var(--info)' : '',
                  }}
                >
                  {unit.name}
                </span>
                {/* {data ? (
                  <custombadge
                    color={data?.find(x => x.id === unit.id)?.openCases || 0 ? 'danger' : 'success'}
                    style={{ fontSize: 12, marginLeft: 8 }}
                    pill
                  >
                    {data?.find(x => x.id === unit.id)?.openCases || 0}
                  </CustomBadge>
                ) : (
                  <Loader dots sm className={'ml-2'} />
                )} */}
              </div>
              {(unit?.roles || []).map((role_our, r_index) => (
                <div style={{ fontSize: 12 }} key={r_index} className="role">
                  {role_our?.role?.name}
                </div>
              ))}
            </DropdownItem>
          </React.Fragment>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default DropdownOrganizationSelected;
